export default "__VITE_ASSET__5b8b84c3__"